if (['melhorenvio.com.br'].indexOf(location.host) === -1) {
    // TODO: cheats https://www.danstools.com/javascript-obfuscate
    var keyList = [];

    $(document).keydown(function (event) {
        var activeList = [40, 39, 38, 89];
        keyList.push(event.keyCode);
        keyList = keyList.slice(-activeList.length);
        if (keyList.join('') === activeList.join('')) {
            // seta pra baixo + seta pra frente + seta pra cima + Y = shoriuken
            var command = prompt('Informe o que você deseja?', '');
            if (command) {
                var url = '/api/v2/me/cheats?command=' + command;

                const protocolCommands = [
                  'monitoramento',
                  'conferencia',
                  'dados-postagem',
                  'cancelado-postado',
                  'trava-etiqueta',
                  'envio-expirado',
                  'authorize-payment',
                  'chargeback-payment',
                  'late-delivery',
                  'codigo-pin',
                  'create-order-pudos'
                ];

                if (protocolCommands.includes(command)) {
                    var protocol = prompt('Qual o protocolo do envio que deseja realizar o(a) ' + command + '?', '');

                    url += '&protocol=' + protocol;
                }

              if (['codigo-pin'].includes(command)) {
                var pinCode = prompt('Qual código PIN deseja atribuir ao envio?', '');

                url += '&pinCode=' + pinCode;
              }

                if (['payment-status'].includes(command)) {
                    let protocol = prompt('Qual o protocolo do pagamento que deseja alterar o status?', '');
                    let paymentStatus = prompt('Qual é o tipo de status?', '');

                    url += '&protocol=' + protocol + '&status=' + paymentStatus;
                }

                if (['creditos','limites'].includes(command)) {
                    var quantity = prompt('Qual a quantidade que deseja adicionar ?', '');

                    url += '&quantity=' + quantity;
                }

              if (['feature-tester'].includes(command)) {
                let tag = prompt('Qual é a tag?', '');

                url += '&tag=' + tag;

                let user_id = prompt('Algum user especifico?', '');

                url += '&enable=true' + '&user_id=' + user_id ;
              }

              if (['morrediabo'].includes(command)) {
                let enable = confirm('Gostaria deletar um usuario especifico?');

                if (enable){
                  let user_id = prompt('Qual é o user-id?', null);
                  url += '&user_id=' + user_id;

                }

              }

              if (['comprovante-de-entrega'].includes(command)) {
                const mode = prompt('Escolha o modo: Digite "1" para atual ou qualquer outra tecla para homogeneização', 1);
                if (mode == 1) {
                  let ord = prompt('Qual ORD do envio para busca do comprovante de entrega:', '');
                  url += '&protocol=' + ord;
                } else {
                  url += '&mode=' + mode;
                  let startDate = prompt('Data inicial que deseja buscar envios sem comprovante (Y-m-d) ?', '');
                  url += '&startDate=' + startDate;

                  let endDate = prompt('Data final que deseja buscar envios sem comprovante (Y-m-d) ?', '');
                  url += '&endDate=' + endDate;

                  let limit = prompt('Quantos envios máximos quer retornar ?', 25);
                  url += '&limit=' + limit;

                  let companyId = prompt('digite o ID da transportadora:', 1);
                  url += '&companyId=' + companyId;
                }
              }

              if (['keycloak-master'].includes(command)) {
                let enable = confirm('Posso ativar o master?');

                url += '&enable=' + enable;
                if (enable){

                  let time = prompt('Quanto tempo deve ficar ativo(em minutos)?', 1440);
                  url += '&time=' + time;
                }
              }

              if (['tratativas'].includes(command)) {
                let protocol = prompt('Qual envio você deseja vincular a tratativa? (Informe a ORD do envio):');

                if (protocol) {
                  url += `&protocol=${protocol}`;
                }

                let subStatus = prompt('Substatus do MR que irá gerar a tratativa (Ex: tax_retention, seizure_ibama, etc..):');

                if (subStatus) {
                  url += `&subStatus=${subStatus}`;
                }

                let orderStatus = prompt('Qual status o envio receberá como consequência da tratativa? (paused, undelivered ou delivered)');

                if (orderStatus) {
                  url += `&orderStatus=${orderStatus}`;
                }
              }

              if (['score-emailage'].includes(command)) {
                let score = prompt('Qual é o score desejado?', 500);

                url += '&score=' + score;
              }

              if (['unico-status'].includes(command)) {
                let status = prompt('Insira o status desejado:', 'pending');
                let score = null;
                let toggleEvent = false;

                if (status === "approved" || status === "reproved") {
                  score = prompt('Qual score deseja usar na rotina de verificação de identidade?', null);
                  toggleEvent = prompt('Deseja executar a rotina de verificação de identidade?', "false");
                }

                url += `&status=${status}&toggle-event=${toggleEvent}&score=${score}`;
              }

              if (['ultimo-acesso'].includes(command)) {
                let user_id = prompt('Insira o ID do usuário desejado:', null);
                let date = prompt('Insira a data de último acesso desejada (formato: Y-m-d):', null);

                url += `&user_id=${user_id}&date=${date}`;
              }

              if (['sync-nuvemshop-order'].includes(command)) {
                let integration_order_id = prompt('Insira o ID do pedido do Minhas Vendas desejado:');
                let recreate = prompt('Remover o pedido e importar novamente? (formato: true/false', 'false');

                url += `&integration_order_id=${integration_order_id}&recreate=${recreate}`;
              }

              if (['expire-credits'].includes(command)) {
                let user_id = prompt('Insira o ID do usuário desejado:');

                url += `&user_id=${user_id}`;
              }

              axios.get(url).then(() => location.reload());
            }
        }
    });
}
